<div class="product-page" *ngIf="product">
  <div class="grid">
    <div class="col-6">
      <ui-gallery [images]="product.images"></ui-gallery>
    </div>
    <div class="col-6 product">
      <h2 class="product-name">{{ product.name }}</h2>
      <p class="product-desc">{{ product.description }}</p>
      <div class="product-rating">
        <p-rating
          [(ngModel)]="product.rating"
          [disabled]="true"
          [cancel]="false"
        ></p-rating>
      </div>
      <div class="product-price">
        {{ product.price | currency }}
        <span class="price-before">{{ product.price + 20 | currency }}</span>
      </div>
      <div class="product-quantity">
        <div class="field col-12 md:col-3 p-0">
          <label for="minmax">Quantity</label>
          <p-inputNumber
            [showButtons]="true"
            [(ngModel)]="quantity"
            inputId="minmax"
            inputId="minmax"
            mode="decimal"
            [min]="1"
            [max]="10"
          >
          </p-inputNumber>
        </div>
      </div>
      <div class="product-actions">
        <button
          pButton
          pRipple
          type="button"
          label="Buy Now"
          class="p-button-rounded mr-2"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          label="Add to Cart"
          class="p-button-rounded mr-2"
          (click)="addProductToCart()"
        ></button>
      </div>
    </div>
  </div>
  <div class="grid product-rich-desc">
    <div class="col-12">
      <div [innerHTML]="product.richDescription"></div>
    </div>
  </div>
</div>
